<template>
	<section :class="!hideContainer && 'container'">
		<RichText
			v-editable="blok"
			:data="blok.content"
		/>
	</section>
</template>

<script setup lang="ts">
	import type {WysiwygStoryblok} from '@/storyblok/types';

	interface Props {
		blok: WysiwygStoryblok;
		hideContainer?: boolean;
	}

	defineProps<Props>();
</script>
